import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, share } from 'rxjs/operators';
import { IEnvironmentService, Value } from '../../../../core/services/environment/environment.interface';
import {
  GroupsData,
  PresetListType,
  SettingsResponseGroup,
  SettingsResponse,
  FieldType,
  FieldsGroups,
} from '../../../reporting/reports-builder/services/reports-builder/responses/settings.response';
import { ReportsBuilderPresetServiceInterface } from './reports-builder-preset.interface';
import { getColumnGroup, getColumnGroupName } from '../../../../core/helpers/report-builder';
import { ICondition } from '@platform500services/p500-ui-kit';

@Injectable({
  providedIn: 'root',
})
export class ReportsBuilderPresetService implements ReportsBuilderPresetServiceInterface {
  private url: string | Value;

  constructor(@Inject('IEnvironmentService') private envService: IEnvironmentService, private http: HttpClient) {
    this.url = this.envService.getVar('services.api');
  }

  private getGroupFields(fields: FieldType): FieldsGroups {
    const groups = getColumnGroupName(fields);
    return getColumnGroup(fields, groups);
  }

  getPresetList(): Observable<PresetListType[]> {
    return this.http.get<SettingsResponse>(`${this.url}/reporting/available`).pipe(
      map((groupsData): PresetListType[] => {
        return Object.entries(groupsData)
          .reduce((acc, [key, group]): PresetListType[] => {
            const fields = Object.entries(group.fields);

            const currentPreset = group.availablePresets.map((preset) => {
              const excluded = preset.excluded.map((data) => data.key);
              const columns = fields
                .filter(([keyField]) => {
                  return !excluded.includes(keyField);
                })
                .map(([, valueField]) => {
                  return valueField;
                })
                .join(', ');

              return {
                ...preset,
                group: group.name,
                groupKey: key,
                columns,
              };
            });

            return [...acc, ...currentPreset];
          }, [])
          .sort((presetRowPreview, presetRowCurrent) => {
            return presetRowPreview.id - presetRowCurrent.id;
          });
      }),
      share()
    );
  }

  getGroups(): Observable<GroupsData> {
    return this.http.get<SettingsResponseGroup>(`${this.url}/reporting/available`).pipe(
      map((data): GroupsData => {
        const settingsData = {};
        Object.entries(data).forEach(([keyGroup, group]) => {
          settingsData[keyGroup] = {
            ...group,
            fieldsGroup: this.getGroupFields(group.fields),
            conditions: Object.entries(group.availableConditions).map(([key, value]): ICondition => {
              return {
                key,
                type: value.type,
                label: value.name,
              };
            }),
          };
        });

        return settingsData;
      })
    );
  }

  savePreset(key, preview, params) {
    return this.http.post<any>(`${this.url}/reporting/generate`, {
      key,
      preview,
      params: params.params,
      excluded: params.excluded,
    });
  }
}
